module.exports = __webpack_public_path__ + "img/photo-stock.eb091550.png";